import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  deleteAppointment,
  getSellerAppointments,
  getUserAppointments,
} from '../api';
import List from '../components/core/List';
import Wrapper from '../components/core/Wrapper';
import InfoCard from '../components/InfoCard';
import YesNoPrompt from '../components/Modals/YesNoPrompt';
import Pagination from '../components/Pagination/Pagination';
import { handleGlobalApiCalls } from '../helpers/asyncActions';
import { getPropertyThumbnail } from '../helpers/images';
import { getFormattedMeetingDate } from '../helpers/time';
import { useGlobalContext } from '../stores/global';

export default function SellerAppointments(props: any) {
  const { dispatch, isLoading } = useGlobalContext();
  const [triggerReload, setTriggerReload] = useState(false);
  const [appointmentToDelete, setappointmentToDelete] = useState<string>();
  let title = 'MIS CITAS';
  let apiFn = getUserAppointments;

  if (props.match.path === '/seller/appointments') {
    title = 'CITAS DE MIS PROPIEDADES';
    apiFn = getSellerAppointments;
  }

  const closeDialog = () => {
    setappointmentToDelete(undefined);
  };

  const handleDelete = () => {
    if (!appointmentToDelete) return;

    handleGlobalApiCalls(dispatch, isLoading, null, () =>
      deleteAppointment(appointmentToDelete)
        .then(() => setTriggerReload(!triggerReload))
        .then(() => closeDialog())
    );
  };

  return (
    <Pagination
      triggerReload={triggerReload}
      apiFn={apiFn}
      render={(items, isLoading, error, paginationEl) => (
        <Wrapper subHeader={{ title: title }}>
          {isLoading ? (
            <p>Cargando...</p>
          ) : !!error ? (
            <p>Error cargando citas</p>
          ) : items?.length === 0 ? (
            <p>No tienes citas</p>
          ) : (
            <List>
              {items?.map((appointment: any, idx) => (
                <InfoCard
                  key={idx}
                  image={getPropertyThumbnail(appointment.property.attaches)}
                  title={appointment.property.description}
                  highlight={appointment.property.info.type}
                  items={[
                    [appointment.property.address?.name],
                    [
                      'Cita programada para',
                      getFormattedMeetingDate(
                        appointment.meetAt,
                        appointment.property.meetingInterval
                      ),
                    ],
                    ['Correo electrónico', appointment.information?.email],
                    ['Teléfono', appointment.information?.phone],
                    [
                      'Tipo de visita',
                      appointment.type === 'presencial'
                        ? 'En Persona'
                        : 'Virtual',
                    ],
                    ['Mensaje', appointment.body],
                  ]}
                  actionItems={[
                    <Link
                      to={`/properties/${appointment.property.id}`}
                      target="_blank"
                    >
                      <i className="fonticons fonticons-navigation-dir" />
                    </Link>,
                    <button
                      aria-label="Eliminar"
                      onClick={() => setappointmentToDelete(appointment._id)}
                    >
                      <i className="fonticons fonticons-trash" />
                    </button>,
                  ]}
                />
              ))}
            </List>
          )}

          {paginationEl}

          <YesNoPrompt
            open={typeof appointmentToDelete !== 'undefined'}
            title="Eliminar cita"
            text="Seguro que desea eliminar esta cita?"
            onClose={closeDialog}
            onYes={handleDelete}
          />
        </Wrapper>
      )}
    />
  );
}
